import React from "react";
import { Table } from "antd";

const ClassSubscribedTab = ({ data }) => {
  // Helper function to format duration (in seconds) to human-readable format
  const formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return "0s";
    
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    
    const parts = [];
    if (hrs > 0) parts.push(`${hrs}h`);
    if (mins > 0) parts.push(`${mins}m`);
    if (secs > 0 || parts.length === 0) parts.push(`${secs}s`);
    
    return parts.join(" ");
  };

  return (
    <Table
      dataSource={data}
      rowKey={(r) => r.id}
      pagination={false}
      columns={[
        { title: "Class Name", dataIndex: "title" },
        {
          title: "Watch Time",
          dataIndex: "duration",
          render: (duration) => formatDuration(duration),
          // Optional: Add sorting
          sorter: (a, b) => a.duration - b.duration,
        },
        {
          title: "Subscribed At",
          dataIndex: "created_at",
          render: (v) => new Date(v).toLocaleString(),
        },
      ]}
    />
  );
};

export default ClassSubscribedTab;